<template>
  <div>
    <div class="y-form-group">
      <el-row class="y-form-group-header">
        <el-col class="y-form-group-header__icon icon-setup-contact" :span="4">&nbsp;</el-col>
        <el-col
          class="y-form-group-header__text"
          :span="20"
        >{{ $lang.messages.setup_header_contact }}</el-col>
      </el-row>
      <div class="y-form-item-group">
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <div class="y-form-row y-form-row__fullwidth">
              <label
                class="y-form-label y-form-label__heavy is-required"
              >{{ $lang.messages.form_label_handling_support }}</label>
              <el-radio-group
                class="y-radio-group y-radio-group__vertical"
                v-model="tier1CustomerCare"
              >
                <el-radio label="CHANNEL_PARTNER">{{channelName}}</el-radio>
                <el-radio label="SUBBRAND">Customer: {{customerName}}</el-radio>
              </el-radio-group>
            </div>
            <div class="ref-flow-subbrand clearfix" v-show="tier1CustomerCare == 'SUBBRAND'">
              <div class="y-form-row y-form-row__fullwidth">
                <span class="y-form-hint-text">{{ $lang.messages.form_hint_contact_subbrand_flow }}</span>
              </div>
            </div>
          </el-col>
          <template v-for="(member, index) in members">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" :key="index">
              <div class="y-form-sub-header">
                <div class="y-form-row y-form-row__fullwidth">
                  <el-row>
                    <el-col :span="14">
                      <span
                        class="y-form-sub-head__text"
                      >{{ $lang.messages.form_sub_head_contact }} {{index + 1}}</span>
                    </el-col>
                    <el-col :span="10" v-if="index > 0">
                      <el-button
                        class="y-button y-warning-button"
                        @click="deleteContact(index)"
                      >{{ $lang.messages.form_btn_delete_contact }}</el-button>
                    </el-col>
                  </el-row>
                </div>
                <div
                  class="y-form-row y-form-row__fullwidth clearfix"
                  v-show="tier1CustomerCare == 'SUBBRAND'"
                >
                  <template v-if="!member.password || member.password == ''">
                    <label
                      class="y-form-label y-form-label__heavy is-required"
                    >{{ $lang.messages.form_label_login_id_for_contact }}</label>
                    <el-input
                      v-model="member.userId"
                      placeholder="Login ID"
                      class="y-form-input y-form-input__small"
                      :class="errors.first('loginId'+index) ? 'y-form-input-error':''"
                      style="width:300px"
                      data-vv-validate-on="change"
                      data-vv-as="Login Id"
                      :name="'loginId'+index"
                      v-validate="{ required: true, min: 6, max: 50, alpha_num: true, regex: '^[a-zA-Z]+[a-zA-Z0-9]*$'}"
                    ></el-input>
                    <span class="y-form-error errorField" v-show="errors.first('loginId'+index)">
                      <i class="el-icon-warning"></i>
                      {{ errors.first('loginId'+index )}}
                    </span>
                  </template>
                  <template v-if="member.password && member.password != ''">
                    <label
                      class="y-form-label y-form-label__heavy"
                    >{{ $lang.messages.form_label_login_id }}</label>
                    <el-row>
                      <el-col :span="10">
                        <span class="y-form-inline-data">{{member.userId}}</span>
                      </el-col>
                      <el-col :span="14">
                        <el-button
                          class="y-button y-warning-button"
                          :disabled="member.resetPassword"
                          @click="resetPassword(index)"
                        >{{ $lang.messages.form_btn_reset_password }}</el-button>
                      </el-col>
                    </el-row>
                  </template>
                </div>
                <div class="y-form-row y-form-row__fullwidth clearfix">
                  <label
                    class="y-form-label y-form-label__heavy is-required"
                  >{{ $lang.messages.form_label_name }}</label>
                  <div class="y-form-pre-post-ctr">
                    <el-input
                      v-model="member.firstName"
                      placeholder="First"
                      class="y-form-input y-form-input__small y-form-pre-input"
                      :class="errors.first('firstName'+index) ? 'y-form-input-error':''"
                      style="width:150px"
                      data-vv-validate-on="change"
                      data-vv-as="First Name"
                      :name="'firstName'+index"
                      v-validate="{required:true, min: 2, max:50, alpha: true}"
                    ></el-input>
                    <el-input
                      v-model="member.lastName"
                      placeholder="Last"
                      class="y-form-input y-form-input__small y-form-post-input"
                      :class="errors.first('lastName'+index) ? 'y-form-input-error':''"
                      style="width:150px"
                      data-vv-validate-on="change"
                      data-vv-as="Last Name"
                      :name="'lastName'+index"
                      v-validate="{required:true, min: 2, max:50, alpha: true}"
                    ></el-input>
                  </div>
                  <span class="y-form-error errorField" v-show="errors.first('firstName'+index)">
                    <i class="el-icon-warning"></i>
                    {{ errors.first('firstName'+index )}}
                  </span>
                  <span class="y-form-error errorField" v-show="errors.first('lastName'+index)">
                    <i class="el-icon-warning"></i>
                    {{ errors.first('lastName'+index) }}
                  </span>
                </div>
                <div class="y-form-row y-form-row__fullwidth clearfix">
                  <label
                    class="y-form-label y-form-label__heavy is-required"
                  >{{ $lang.messages.form_label_phone }}</label>
                  <div class="y-form-pre-post-ctr">
                    <el-select
                      v-model="member.contryCode"
                      class="y-form-select y-form-select__small y-form-pre-select"
                      placeholder="+1"
                      style="width:60px"
                    >
                      <el-option label="+91" value="91"></el-option>
                    </el-select>
                    <el-input
                      v-model="member.contactNumber"
                      placeholder="### - ### - ####"
                      class="y-form-input y-form-input__small y-form-post-input"
                      :class="errors.first('phone'+index) ? 'y-form-input-error':''"
                      style="width:155px"
                      data-vv-validate-on="change"
                      data-vv-as="Phone"
                      :name="'phone'+index"
                      v-validate="{required:true}"
                    ></el-input>
                  </div>
                  <span class="y-form-error errorField" v-show="errors.first('phone'+index)">
                    <i class="el-icon-warning"></i>
                    {{errors.first('phone'+index)}}
                  </span>
                </div>
                <div class="y-form-row y-form-row__fullwidth clearfix">
                  <label
                    class="y-form-label y-form-label__heavy is-required"
                  >{{ $lang.messages.form_label_email }}</label>

                  <el-input
                    v-model="member.email"
                    placeholder="Email"
                    class="y-form-input y-form-input__small"
                    :class="errors.first('email'+index) ? 'y-form-input-error':''"
                    style="width:300px"
                    data-vv-validate-on="change"
                    data-vv-as="Email"
                    :name="'email'+index"
                    v-validate="{required:true, max: 50, email:true}"
                  ></el-input>

                  <span class="y-form-error errorField" v-show="errors.first('email'+index)">
                    <i class="el-icon-warning"></i>
                    {{errors.first('email'+index)}}
                  </span>
                </div>
                <div
                  class="y-form-row y-form-row__fullwidth clearfix"
                  v-if="members.length != maxContactCount"
                >
                  <el-link class="y-form-link" @click="addNewContact">
                    <i class="el-icon-circle-plus-outline"></i>
                    {{ $lang.messages.form_link_Add_another_contact }}
                  </el-link>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" :key="index+10"></el-col>
          </template>
        </el-row>
      </div>
      <el-button class="y-button" @click="saveContact">Save</el-button>
    </div>
    <el-dialog
      :visible.sync="showPopupResetPassword"
      custom-class="y-message-popup no-title-bar"
      width="400px"
    >
      <span>Password will be reset and sent to each contact once the subbrand is published.</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopupResetPassword = false" type="primary">Got it</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import serviceRegistery from '../../mixins/serviceRegistery'
export default {
  name: 'SetupContact',
  inject: ['$validator'],
  components: {},
  data() {
    return {
      maxContactCount: 2,
      showPopupResetPassword: false
    }
  },
  computed: {
    tier1CustomerCare: {
      get() {
        var setupData = this.$store.state.createSubbrandStore.setupTemplateData
        var generalConfig = setupData.config.generalConfig
        return generalConfig.tier1CustomerCare
      },
      set(value) {
        var setupData = this.$store.state.createSubbrandStore.setupTemplateData
        var generalConfig = setupData.config.generalConfig
        generalConfig.tier1CustomerCare = value
      }
    },
    members() {
      var setupData = this.$store.state.createSubbrandStore.setupTemplateData
      return setupData.config.contacts.members
    },
    customerName() {
      var setupData = this.$store.state.createSubbrandStore.setupTemplateData
      return setupData.name
    },
    channelName() {
      var channelName = 'MY NEW Channel'
      return channelName
    }
  },
  created() {},
  methods: {
    addNewContact() {
      var newMember = {
        loginId: '',
        resetPassword: false,
        firstName: '',
        lastName: '',
        email: '',
        contryCode: '',
        phone: ''
      }
      this.members.push(newMember)
    },
    deleteContact(index) {
      this.members.splice(index, 1)
    },
    resetPassword(index) {
      console.log(this.members[index])
      this.showPopupResetPassword = true
      this.members[index].resetPassword = true
    },
    saveContact() {
      console.log('Save Contact')
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log('All Valid')
        }
      })
      var subbrandDataObj = {
        config: {
          contacts: {
            members: this.members
          }
        }
      }
      let _id = this.$store.state.appStore.selectedSubbrandInfo._id
      let reqObj = {
        id: _id,
        jsonData: JSON.stringify(subbrandDataObj)
      }

      console.log('Update Request Obj------>', subbrandDataObj)
      if (_id) {
        serviceRegistery
          .makeCall({
            url: this.$hostname + 'services/subbrand/update',
            method: 'POST',
            data: reqObj
          })
          .then(response => {
            console.log(response)
            console.log('Sub-brand Data Updated-->', response.data)
            this.$store.state.appStore.selectedSubbrandInfo = response.data
          })
          .catch(error => {
            console.log('Error while updating', error.response.data)
          })
      } else {
        console.log('Sub-brand not avaliable to save')
      }
    }
  }
}
</script>

<style>
.main-ctr {
  width: 100%;
  display: block;
}
</style>
